/**
 * Teeinblue Preview Sync (PC only)
 * Watches the hidden Teeinblue gallery, copies .tee-mockup content into the
 * product slideshow preview slide, and switches to it when the Preview thumb
 * is clicked.
 */

(function () {
  'use strict';

  var POLL_INTERVAL = 200;
  var MAX_POLL_ATTEMPTS = 100; // 20 seconds

  function getFlickityInstance(el) {
    if (!el) return null;
    if (el.flickity) return el.flickity;
    if (typeof Flickity !== 'undefined' && Flickity.data) {
      return Flickity.data(el);
    }
    return null;
  }

  function getSignature(node) {
    if (!node) return '';
    // Full innerHTML comparison plus printarea display/opacity state.
    // Teeinblue toggles inline styles on .tee-printarea without changing
    // innerHTML, so we must include those to avoid skipping legitimate updates.
    var parts = [(node.innerHTML || '')];
    var printareas = node.querySelectorAll('.tee-printarea');
    for (var i = 0; i < printareas.length; i++) {
      parts.push(printareas[i].style.display || '');
      parts.push(printareas[i].style.opacity || '');
    }
    return parts.join('|');
  }

  function scaleToContainer(mockupEl, containerEl) {
    // Use offsetWidth/Height of the container (layout values, not affected
    // by visibility). For the mockup, prefer explicit inline dimensions
    // (set by syncPreview), and fall back to layout measurements.
    var cw = containerEl.offsetWidth;
    var ch = containerEl.offsetHeight;
    var sw = parseFloat(mockupEl.style.width);
    var sh = parseFloat(mockupEl.style.height);
    if (!sw || !sh) {
      sw = mockupEl.offsetWidth;
      sh = mockupEl.offsetHeight;
    }

    console.log('sw', sw, 'sh', sh, 'cw', cw, 'ch', ch);
    if (!sw || !sh) return;

    if (cw && ch) {
      var scale = Math.min(cw / sw, ch / sh);
      mockupEl.style.transform = 'translate(-50%, -50%) scale(' + scale + ')';
    } else {
      mockupEl.style.maxWidth = '100%';
      mockupEl.style.maxHeight = '100%';
      mockupEl.style.top = '50%';
      mockupEl.style.left = '50%';
      mockupEl.style.transform = 'translate(-50%, -50%)';
    }
  }

  function initSection(sectionEl) {
    // console.log('[TeePreviewSync] initSection for section', sectionEl.getAttribute('data-section-id'));
    var galleryWrapper = sectionEl.querySelector('#teeinblue-gallery');

    function enablePreview() {
      // Mark the section so CSS shows the Preview thumb/slide for this
      // product only. Products without Teeinblue keep them hidden.
      sectionEl.classList.add('has-teeinblue-gallery');

      var previewThumb = sectionEl.querySelector('.product__thumb--preview');
      var previewSlide = sectionEl.querySelector('.product-main-slide--preview');

      // Clone the Preview slide from the <template> and insert it into the
      // Flickity slider. Stored in a <template> by default so it is NOT a
      // Flickity cell on products without Teeinblue — that way swiping left
      // can never enter a hidden/empty slide and cause height collapse.
      if (!previewSlide) {
        var template = sectionEl.querySelector('template[id^="preview-slide-template"]');
        if (template && template.content.firstElementChild) {
          previewSlide = template.content.firstElementChild.cloneNode(true);
          var productPhotos = sectionEl.querySelector('[data-product-photos]');
          var flickity = getFlickityInstance(productPhotos);

          if (flickity && typeof flickity.insert === 'function') {
            // Flickity already initialized — use its insert() API to add the
            // slide as cell 0. insert() properly manages the cells array and
            // shifts selectedIndex by +1 so the currently-visible product
            // image stays selected (no manual reloadCells/select needed,
            // which can corrupt Flickity's selectedCell reference and crash
            // on the next dragEnd -> updateSelected).
            flickity.insert(previewSlide, 0);
            if (typeof flickity.resize === 'function') {
              requestAnimationFrame(function () { flickity.resize(); });
            }
          } else {
            // Flickity not yet initialized — insert as first child directly;
            // Flickity picks it up on init and theme.js handles the index shift.
            productPhotos.insertBefore(previewSlide, productPhotos.firstChild);
          }

          // Belt-and-suspenders: Flickity's insert() can re-position the
          // pageDots (which are absolutely-positioned) into a transient
          // broken state on PC, where they appear as a stray vertical line
          // between the first and second cells. The theme already hides
          // .product__main-photos .flickity-page-dots on desktop via CSS,
          // but the dots are siblings of .flickity-slider, not children of
          // .product__main-photos — so the CSS selector does not match.
          // We explicitly hide any pageDots for this slider on PC.
          if (window.innerWidth >= 768) {
            requestAnimationFrame(function () {
              var dots = productPhotos.parentElement.querySelectorAll('.flickity-page-dots');
              dots.forEach(function (d) { d.style.display = 'none'; });
            });
          }
        }
      }

      var previewContainer = previewSlide ? previewSlide.querySelector('[data-preview-container]') : null;
      if (!previewThumb || !previewContainer) return;

      setupPreviewSync(sectionEl, previewThumb, previewSlide, previewContainer);
    }

    // If .tee-gallery-content is already there, enable immediately.
    if (sectionEl.querySelector('#teeinblue-gallery > .tee-gallery-content')) {
      enablePreview();
      return;
    }
    // Otherwise watch #teeinblue-gallery for Teeinblue to inject
    // .tee-gallery-content. Bail out after a timeout if it never appears —
    // that means this product doesn't have Teeinblue enabled and we should
    // leave the Preview elements hidden.
    if (!galleryWrapper) {
      // console.log('[TeePreviewSync] no #teeinblue-gallery in section, skip');
      return;
    }
    // console.log('[TeePreviewSync] .tee-gallery-content not yet present, watching #teeinblue-gallery');
    var attempts = 0;
    var maxAttempts = 100; // ~10s at 100ms
    var mo = new MutationObserver(function () {
      if (sectionEl.querySelector('#teeinblue-gallery > .tee-gallery-content')) {
        // console.log('[TeePreviewSync] .tee-gallery-content appeared, enabling Preview');
        mo.disconnect();
        enablePreview();
        return;
      }
      attempts++;
      if (attempts > maxAttempts) {
        // console.log('[TeePreviewSync] .tee-gallery-content never appeared, skip');
        mo.disconnect();
      }
    });
    mo.observe(galleryWrapper, { childList: true, subtree: true });
  }

  // The rest of the preview sync setup runs only once .tee-gallery-content
  // is confirmed present. Everything below this point used to live directly
  // inside initSection, but is now deferred so that products which don't
  // have Teeinblue skip the whole pipeline cleanly.
  function setupPreviewSync(sectionEl, previewThumb, previewSlide, previewContainer) {

    var isSyncing = false;
    var lastSignature = '';
    var clonedMockup = null;
    var mockupObserver = null;
    var galleryObserver = null;
    var pollTimer = null;

    // Each sync we re-assert the preview elements' visibility. Teeinblue
    // occasionally re-injects CSS that ends up hiding the preview thumb /
    // slide again; we strip any display: none we find on them at the
    // outermost preview elements so the user always sees them.
    function ensurePreviewVisible() {
      var thumbItem = sectionEl.querySelector('.product__thumb-item--preview');
      var thumbLink = sectionEl.querySelector('.product__thumb--preview');
      var slide = sectionEl.querySelector('.product-main-slide--preview');
      var container = sectionEl.querySelector('[data-preview-container]');
      if (thumbItem && (thumbItem.style.display === 'none' || getComputedStyle(thumbItem).display === 'none')) {
        thumbItem.style.display = '';
      }
      if (thumbLink && (thumbLink.style.display === 'none' || getComputedStyle(thumbLink).display === 'none')) {
        thumbLink.style.display = '';
      }
      if (slide && (slide.style.display === 'none' || getComputedStyle(slide).display === 'none')) {
        slide.style.display = '';
      }
      if (container && (container.style.display === 'none' || getComputedStyle(container).display === 'none')) {
        container.style.display = '';
      }
    }
    // Run once immediately, in case a later Teeinblue CSS injection already
    // hid the preview elements between enablePreview() and the first sync.
    ensurePreviewVisible();

    function getProductPhotos() {
      return sectionEl.querySelector('[data-product-photos]');
    }

    function switchToPreview(attempt) {
      attempt = attempt || 0;
      var productPhotos = getProductPhotos();
      var flickity = getFlickityInstance(productPhotos);

      if (flickity && typeof flickity.select === 'function') {
        flickity.select(0);
        // Resize after the selection so adaptiveHeight picks up the preview
        // slide's height correctly.
        if (typeof flickity.resize === 'function') {
          requestAnimationFrame(function () {
            flickity.resize();
          });
        }
        return;
      }

      // Flickity may not be initialized yet; retry briefly
      if (attempt < 30) {
        setTimeout(function () {
          switchToPreview(attempt + 1);
        }, 200);
      }
    }

    function syncPreview(teeMockup) {
      if (isSyncing) {
        // console.log('[TeePreviewSync] syncPreview skipped, already syncing');
        return;
      }
      // Re-assert the preview elements are visible — Teeinblue may have
      // re-applied display:none between syncs.
      ensurePreviewVisible();

      // Teeinblue may swap .tee-mockup nodes; always re-query the current one
      // so a stale reference doesn't make us clone an empty detached node.
      var liveGallery = findGalleryContent();
      var liveMockup = liveGallery ? liveGallery.querySelector('.tee-mockup') : null;
      var sourceMockup = liveMockup || teeMockup;
      if (!sourceMockup) {
        // console.log('[TeePreviewSync] no tee-mockup found, skip');
        return;
      }
      // console.log('[TeePreviewSync] source mockup children', sourceMockup.children.length, 'innerHTML length', (sourceMockup.innerHTML || '').length);

      // On mobile, wait until tee-printarea has valid dimensions before
      // copying. Teeinblue sets these async, and copying too early
      // results in wrong sizing on the first render.
      if (window.innerWidth < 768) {
        var printarea = sourceMockup.querySelector('.tee-printarea');
        if (printarea) {
          var pw = parseInt(printarea.style.width, 10);
          if (pw <= 0) {
            // console.log('[TeePreviewSync] tee-printarea not ready, waiting...');
            return;
          }
        }
      }

      var currentSignature = getSignature(sourceMockup);
      // console.log('[TeePreviewSync] syncPreview signature', currentSignature, 'last', lastSignature);
      if (currentSignature === lastSignature) {
        // console.log('[TeePreviewSync] signature unchanged, skip');
        return;
      }

      isSyncing = true;

      var isMobile = window.innerWidth < 768;

      requestAnimationFrame(function () {
        var existingCloned = previewContainer.querySelector('.tee-mockup--cloned');

        if (!existingCloned) {
          clonedMockup = sourceMockup.cloneNode(true);
          clonedMockup.classList.add('tee-mockup--cloned');
          clonedMockup.removeAttribute('id');

          // Read the original mockup's natural canvas size.
          // Prefer inline width/height because the source may be display:none
          // (hidden gallery), which makes getBoundingClientRect return 0.
          var sw = parseFloat(sourceMockup.style.width);
          var sh = parseFloat(sourceMockup.style.height);
          if (!sw || !sh) {
            var sourceRect = sourceMockup.getBoundingClientRect();
            sw = sourceRect.width;
            sh = sourceRect.height;
          }
          if (!sw || !sh) { sw = 430; sh = 430; }

          // Position at center of container and use original rendered size as the base.
          // Set explicit width/height on the clone so scaleToContainer can
          // compute the right scale even on mobile.
          clonedMockup.style.position = 'absolute';
          clonedMockup.style.top = '50%';
          clonedMockup.style.left = '50%';
          clonedMockup.style.width = sw + 'px';
          clonedMockup.style.height = sh + 'px';
          clonedMockup.style.opacity = '0';
          clonedMockup.style.transition = 'opacity 0.18s ease';

          previewContainer.appendChild(clonedMockup);
        } else {
          clonedMockup = existingCloned;
          clonedMockup.style.opacity = '0';
          clonedMockup.innerHTML = sourceMockup.innerHTML;
          // Update explicit dimensions so scaleToContainer uses the new size
          var sw2 = parseFloat(sourceMockup.style.width);
          var sh2 = parseFloat(sourceMockup.style.height);
          if (!sw2 || !sh2) {
            var sr2 = sourceMockup.getBoundingClientRect();
            sw2 = sr2.width;
            sh2 = sr2.height;
          }
          if (sw2 && sh2) {
            clonedMockup.style.width = sw2 + 'px';
            clonedMockup.style.height = sh2 + 'px';
          }
        }

        lastSignature = currentSignature;
        // console.log('[TeePreviewSync] preview content copied, innerHTML length', (sourceMockup.innerHTML || '').length);

        requestAnimationFrame(function () {
          clonedMockup.style.transform = '';
          scaleToContainer(clonedMockup, previewContainer);

          // Fade in on the next frame so the layout is settled
          requestAnimationFrame(function () {
            clonedMockup.style.opacity = '1';
          });

          isSyncing = false;

          if (!existingCloned) {
            var productPhotos = getProductPhotos();
            var flickity = getFlickityInstance(productPhotos);
            if (flickity && typeof flickity.resize === 'function') {
              flickity.resize();
            }
          }
        });
      });
    }

    function rescalePreview() {
      if (!clonedMockup) return;
      clonedMockup.style.transform = '';
      requestAnimationFrame(function () {
        scaleToContainer(clonedMockup, previewContainer);
      });
    }

    function observeMockup(teeMockup) {
      if (mockupObserver) mockupObserver.disconnect();

      // Initial sync
      syncPreview(teeMockup);

      mockupObserver = new MutationObserver(function () {
        syncPreview(teeMockup);
      });

      mockupObserver.observe(teeMockup, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'style', 'class', 'width', 'height']
      });
    }

    function findGalleryContent() {
      // The hidden Teeinblue gallery is usually inside the same section
      return sectionEl.querySelector('.tee-gallery-content');
    }

    function tryStartGalleryObserver() {
      var gallery = findGalleryContent();
      if (!gallery) return false;

      if (galleryObserver) galleryObserver.disconnect();

      galleryObserver = new MutationObserver(function () {
        var teeMockup = gallery.querySelector('.tee-mockup');
        if (teeMockup) {
          observeMockup(teeMockup);
        }
      });

      galleryObserver.observe(gallery, { childList: true, subtree: true });

      var teeMockup = gallery.querySelector('.tee-mockup');
      if (teeMockup) {
        observeMockup(teeMockup);
      }

      return true;
    }

    // Hide the gallery off-screen while keeping it in the DOM so Teeinblue
    // keeps operating on .tee-mockup. We avoid `display: none` because that
    // collapses children rects and breaks Teeinblue's size calculations; we
    // also avoid moving the element out of the document tree because Teeinblue
    // may re-inject it back to its expected parent.
    function ensureGalleryHidden() {
      var gallery = findGalleryContent();
      if (!gallery) return;
      gallery.style.position = 'absolute';
      gallery.style.top = '0';
      gallery.style.left = '-99999px';
      gallery.style.visibility = 'hidden';
      gallery.style.pointerEvents = 'none';
    }

    // On mobile, watch .sticky-gallery-mask. When Teeinblue's sticky gallery
    // becomes visible, we need to show the original .tee-gallery-content so
    // the user can interact with it. When the mask hides, re-hide the gallery.
    function watchStickyMask() {
      if (window.innerWidth >= 768) return;

      var gallery = findGalleryContent();
      if (!gallery) return;

      function showGallery() {
        // Use setProperty with 'important' priority to override the
        // theme.liquid CSS !important rules that hide the gallery.
        gallery.style.setProperty('position', 'fixed', 'important');
        gallery.style.setProperty('top', '0', 'important');
        gallery.style.setProperty('left', '0', 'important');
        gallery.style.setProperty('visibility', 'visible', 'important');
      }

      function hideGallery() {
        gallery.style.setProperty('position', 'absolute', 'important');
        gallery.style.setProperty('top', '0', 'important');
        gallery.style.setProperty('left', '-99999px', 'important');
        gallery.style.setProperty('visibility', 'hidden', 'important');
        gallery.style.setProperty('pointer-events', 'none', 'important');
      }

      var maskObserver = new MutationObserver(function () {
        var mask = document.querySelector('.sticky-gallery-mask');
        if (!mask) return;
        if (mask.style.display === 'none' || getComputedStyle(mask).display === 'none') {
          hideGallery();
        } else {
          showGallery();
        }
      });

      var pollMask = setInterval(function () {
        var mask = document.querySelector('.sticky-gallery-mask');
        if (mask) {
          clearInterval(pollMask);
          maskObserver.observe(mask, { attributes: true, attributeFilter: ['style'] });
          if (mask.style.display !== 'none' && getComputedStyle(mask).display !== 'none') {
            showGallery();
          }
        }
      }, 200);
    }

    function pollForGallery() {
      var attempts = 0;

      function tick() {
        attempts++;
        if (attempts > MAX_POLL_ATTEMPTS) return;

        var gallery = findGalleryContent();
        if (gallery) {
          ensureGalleryHidden();
          tryStartGalleryObserver();
          return;
        }

        pollTimer = setTimeout(tick, POLL_INTERVAL);
      }

      tick();
    }

    // Preview thumb click -> force a fresh sync of the latest mockup content
    // into the preview slide, then switch to it. This guarantees the user
    // always sees the most recent Teeinblue state when they pick Preview.
    previewThumb.addEventListener('click', function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      forceSyncPreview();
      switchToPreview();
    });

    // Watch the right-side form (#teeFormInputs) for user interactions. When
    // the user clicks/changes something there, check if the main slideshow is
    // currently on the Preview slide (Flickity index 0). If not, switch to it
    // immediately. We don't wait for a tee-mockup copy event to fire the
    // switch — we just react to the form interaction directly.
    function bindFormInputs(formInputs) {
      // Bind on the form container AND every descendant, because some
      // Teeinblue widgets stop propagation on inner elements which would
      // otherwise prevent the click from being observed at the container.
      var onFormInteraction = function (evt) {
        // console.log('[TeePreviewSync] form interaction detected', evt && evt.type, 'on', evt && evt.target && (evt.target.tagName + (evt.target.id ? '#' + evt.target.id : '') + (evt.target.className ? '.' + String(evt.target.className).split(' ').join('.') : '')));
        var productPhotos = getProductPhotos();
        var flickity = getFlickityInstance(productPhotos);
        var currentIndex = flickity && typeof flickity.selectedIndex === 'number' ? flickity.selectedIndex : -1;
        // console.log('[TeePreviewSync] current Flickity selectedIndex', currentIndex);
        if (currentIndex !== 0) {
          // console.log('[TeePreviewSync] not on Preview, switching now');
          switchToPreview();
        }
      };
      // Capture phase so we run before any handler that calls stopPropagation
      formInputs.addEventListener('click', onFormInteraction, true);
      formInputs.addEventListener('change', onFormInteraction, true);
      formInputs.addEventListener('input', onFormInteraction, true);
      formInputs.addEventListener('keyup', onFormInteraction, true);
    }

    var existingFormInputs = document.querySelector('#teeFormInputs');
    if (existingFormInputs) {
      bindFormInputs(existingFormInputs);
    } else {
      // Teeinblue injects #teeFormInputs asynchronously; observe until it
      // appears, then bind and disconnect.
      var formObserver = new MutationObserver(function () {
        var node = document.querySelector('#teeFormInputs');
        if (node) {
          bindFormInputs(node);
          formObserver.disconnect();
        }
      });
      formObserver.observe(document.body, { childList: true, subtree: true });
    }

    // Force a sync regardless of signature, so a click on the Preview thumb
    // always shows the freshest mockup content even if no mutation has fired.
    function forceSyncPreview() {
      var liveGallery = findGalleryContent();
      var liveMockup = liveGallery ? liveGallery.querySelector('.tee-mockup') : null;
      if (!liveMockup) return;
      // Bypass the signature short-circuit, and wait for any in-flight sync
      // to release its isSyncing lock so we don't get skipped.
      lastSignature = '';
      // Run in the next macrotask so the in-flight rAF chain completes first
      setTimeout(function () {
        isSyncing = false;
        syncPreview(liveMockup);
      }, 0);
    }

    // Rescale preview when its container size changes or becomes visible
    if (typeof ResizeObserver !== 'undefined') {
      var resizeObserver = new ResizeObserver(function () {
        rescalePreview();
      });
      resizeObserver.observe(previewContainer);
    } else {
      window.addEventListener('resize', rescalePreview);
    }

    // Start watching for gallery / mockup
    if (!tryStartGalleryObserver()) {
      pollForGallery();
    } else {
      ensureGalleryHidden();
    }

    watchStickyMask();
  }

  function initAll() {
    // Only run for product pages that have Teeinblue installed. The presence
    // of #tee-gallery indicates this product page is hooked up to Teeinblue's
    // PERSONALIZE app, which is the only case where we need the preview sync
    // logic. For all other product pages we exit early and don't attach any
    // listeners or observers.
    // We also bail out on non-product pages entirely.
    if (!document.querySelector('[data-section-type="product"]')) {
      return;
    }
    startWhenTeeinblueReady();
  }

  // Teeinblue injects .tee-gallery-content inside #teeinblue-gallery
  // asynchronously. Poll until it appears, and stop polling after a generous
  // timeout to avoid running forever on pages that simply don't have
  // Teeinblue enabled.
  function startWhenTeeinblueReady() {
    if (document.querySelector('#teeinblue-gallery > .tee-gallery-content')) {
      bootstrapSections();
      return;
    }
    var maxAttempts = 50; // ~10 seconds at 200ms
    var attempts = 0;
    var mo = new MutationObserver(function () {
      if (document.querySelector('#teeinblue-gallery > .tee-gallery-content')) {
        mo.disconnect();
        bootstrapSections();
        return;
      }
      attempts++;
      if (attempts > maxAttempts) {
        // console.log('[TeePreviewSync] no .tee-gallery-content detected after polling, skip');
        mo.disconnect();
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function bootstrapSections() {
    // console.log('[TeePreviewSync] Teeinblue detected, bootstrapping preview sync');
    var sections = document.querySelectorAll('[data-section-type="product"]');
    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
